import { __rest } from 'tslib';
import { t } from './i18n.es.js';
import { styled, Button, LazyImage, Link, Tag, Currency, Input, Row, Col, Card, Alerts, Dropdown, ComboImage, DropdownToggle, DropdownMenu } from '@teko/ui';
import React, { useState, useEffect } from 'react';
import styled$1 from '@emotion/styled';
import { S as SellerCard } from './SellerCard-5573cab4.js';
import { A as AppliedCoupon } from './AppliedCoupon-125ff36a.js';
import { L as Loading } from './Loading-432a2ca9.js';
import get from 'lodash.get';
import { getComboImageUrl, getComboName } from './helpers.es.js';
import { G as Gift } from './Gift-48d89956.js';
import { M as MobileLink } from './MobileLink-fcf22e0e.js';
import { P as ProductPrice } from './ProductPrice-aae065f6.js';

const Wrapper$2 = styled.div `
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 32px;
`;
const Description = styled.div `
  color: #848788;
  margin-top: 16px;
  margin-bottom: 24px;
`;
const StyledButton$2 = styled(Button) `
  :hover {
    color: #fff;
  }
`;
const EmptyCartPanel = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(Wrapper$2, Object.assign({}, props),
        React.createElement(LazyImage, { src: "https://i.imgur.com/Drj57qu.png" }),
        React.createElement(Description, null, t('Giỏ hàng chưa có sản phẩm nào')),
        React.createElement(Link, { href: "/", passHref: true },
            React.createElement(StyledButton$2, { tag: "a", variant: "primary" }, t('Mua sắm ngay')))));
};

const StyledTag = styled(Tag)((props) => `
  background-color: ${props.variant == 'primary' ? '#ef2741' : 'grey'};
  margin-right: 5px;
  padding: 2px 8px;
  border-radius: 4px;
`);
const StyledButton$1 = styled(Button) `
  color: #047fff;
  font-weight: normal;
  padding-left: 0;
  padding-top: 3px;
  padding-bottom: 0px;
  &:hover {
    color: #047fff;
  }
  text-decoration: none;
`;
const StyledCouponDetail = styled.div `
  width: 100%;
  text-align: left;
`;
const StyledCurrency = styled(Currency) `
  font-weight: 500;
`;
const StyledContent = styled.span((props) => `
  color: ${props.className == 'disabled' ? 'grey' : 'initial'};
`);
const SuggestedCoupon = ({ text, action, disabled = false, discount, benefit, appliedSellers, orderValueMax, orderValueMin, detail, skus, horizontal = true, }) => {
    const onActionClicked = () => {
        if (action)
            action(`${text}` || '', discount || 0);
    };
    const getPromotionRangeText = (minValue, maxValue) => {
        switch (minValue + maxValue) {
            case 0:
                return React.createElement("span", null, t('cho đơn hàng'));
            case minValue:
                return (React.createElement("span", null,
                    ' ',
                    t('cho đơn hàng tối thiểu'),
                    React.createElement(Currency, { value: minValue })));
            case maxValue:
                return (React.createElement("span", null,
                    ' ',
                    t('cho đơn hàng tối đa'),
                    React.createElement(Currency, { value: maxValue })));
            default:
                return (React.createElement("span", null,
                    ' ',
                    t('cho đơn hàng từ'),
                    React.createElement(Currency, { value: minValue }),
                    t('đến'),
                    " ",
                    React.createElement(Currency, { value: maxValue })));
        }
    };
    return (React.createElement(StyledCouponDetail, null,
        React.createElement("div", null,
            React.createElement(StyledTag, { variant: disabled ? 'secondary' : 'primary' }, text),
            (benefit === null || benefit === void 0 ? void 0 : benefit.discount) ? (React.createElement(StyledContent, { className: disabled ? 'disabled' : 'normal' },
                t('Giảm thêm'),
                ' ',
                benefit.discount.percent ? (React.createElement("span", null,
                    benefit.discount.percent,
                    t('% tối đa'),
                    ' ',
                    React.createElement(StyledCurrency, { value: benefit.discount.maxAmount || 0 }))) : (React.createElement(StyledCurrency, { value: benefit.discount.flat || 0 })),
                getPromotionRangeText(orderValueMin, orderValueMax),
                skus && skus.length > 0 && (React.createElement("span", null, t('có chứa sản phẩm hiện tại'))),
                appliedSellers && React.createElement("span", null,
                    " ",
                    appliedSellers),
                !disabled && (React.createElement(React.Fragment, null,
                    !horizontal && React.createElement("br", null),
                    React.createElement(StyledButton$1, { link: true, onClick: onActionClicked, "data-track-content": true, "data-content-region-name": "selectApplicableCoupon", "data-content-name": text },
                        horizontal && React.createElement(React.Fragment, null, "\u00A0"),
                        t('Áp dụng')))))) : benefit && benefit.money && benefit.money[0] ? (React.createElement(StyledContent, { className: disabled ? 'disabled' : 'normal' },
                t('Giảm thêm'),
                ' ',
                benefit.money[0].discountType === 'percent' ? (React.createElement("span", null,
                    benefit.money[0].percent,
                    t('% tối đa'),
                    React.createElement(StyledCurrency, { value: benefit.money[0].maxDiscount || 0 }))) : (React.createElement(StyledCurrency, { value: benefit.money[0].money || 0 })),
                getPromotionRangeText(orderValueMin, orderValueMax),
                skus && skus.length > 0 && (React.createElement("span", null, t('có chứa sản phẩm hiện tại'))),
                !disabled && (React.createElement(React.Fragment, null,
                    !horizontal && React.createElement("br", null),
                    React.createElement(StyledButton$1, { link: true, onClick: onActionClicked, "data-track-content": true, "data-content-region-name": "applyCoupon", "data-content-name": "applySelectedCoupon" },
                        horizontal && React.createElement(React.Fragment, null, "\u00A0"),
                        t('Áp dụng')))))) : (React.createElement(StyledContent, { className: disabled ? 'disabled' : 'normal' },
                detail,
                !disabled && (React.createElement(StyledButton$1, { link: true, onClick: onActionClicked, "data-track-content": true, "data-content-region-name": "applyCoupon", "data-content-name": "applySelectedCoupon" }, t('Áp dụng'))))))));
};

const AppliedCouponBlock = styled$1.div `
  width: 100%;
  margin-top: 15px;
  margin-bottom: 10px;
`;
const StyledInput = styled$1(Input) `
  height: 40px;
  background-color: #f6f6f6;
  padding-left: 15px;
`;
const StyledButton = styled$1(Button) `
  width: 100%;
  height: 40px;
  color: white;
`;
const StyledRow = styled$1(Row) `
  margin-top: 15px;
`;
const InputBlock = styled$1(Col) `
  padding-right: 0px;
`;
const StyledCard$1 = styled$1(Card) `
  padding: 1rem;
`;
const StyledCoupons = styled$1.div `
  .blockCouponSeller:not(:last-child) {
    padding-bottom: 4px;
    border-bottom: 1.5px dashed #e4e5f0;
  }
`;
const Header = styled$1.p `
  margin: 0;
  color: #333;
  font-size: 0.9375rem;
  line-height: 1.5rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;
const StyledSuggestedCoupon = styled$1.div `
  margin-bottom: 8px;
`;
const StyledAlerts = styled$1(Alerts) `
  margin-bottom: 0.5rem;
`;
const Warning = styled$1.div `
  color: #ffa940;
  margin: 8px 0px;
  border-bottom: 1.5px dashed #e4e5f0;
  padding-bottom: 16px;
`;
const StyledLink = styled$1.a `
  font-weight: 500;
  text-decoration: none;
  white-space: pre;
  cursor: pointer;
  &:hover {
    color: #eb1f3b !important;
  }
`;
const getAppliedSellersText = (applySellerIds = []) => {
    switch (applySellerIds.length) {
        case 0:
            return t('với tất cả các nhà cung cấp');
        default:
            return t('với {{ApplySellerIdsLength}} nhà cung cấp', {
                ApplySellerIdsLength: applySellerIds.length,
            });
    }
};
const StyledAppliedCoupon = styled$1(AppliedCoupon) `
  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;
const CartDiscountSeller = ({ sellerSuggestedCoupons = [], appliedCoupons = [], marketPlaceCoupons = [], onApplyCoupon, onRemoveCoupon, loading, multiSeller, appliedEVouchers = [], isLoggedIn = true, onLogin, }) => {
    const [coupon, setCoupon] = useState('');
    const applyCoupon = () => {
        onApplyCoupon(coupon);
    };
    useEffect(() => {
        var _a, _b;
        setCoupon(((_a = appliedCoupons === null || appliedCoupons === void 0 ? void 0 : appliedCoupons[0]) === null || _a === void 0 ? void 0 : _a.text) || ((_b = appliedEVouchers === null || appliedEVouchers === void 0 ? void 0 : appliedEVouchers[0]) === null || _b === void 0 ? void 0 : _b.voucherCode) || '');
    }, [JSON.stringify(appliedCoupons), JSON.stringify(appliedEVouchers)]);
    return (React.createElement(Loading, { isLoading: loading },
        React.createElement(StyledCard$1, { header: React.createElement("h5", null, t('Mã giảm giá/Phiếu mua hàng')) },
            React.createElement(StyledRow, null,
                React.createElement(InputBlock, { col: 7 },
                    React.createElement(StyledInput, { placeholder: t('Nhập mã của bạn'), value: coupon, onChange: (e) => setCoupon(e.target.value.trim().toUpperCase()) })),
                React.createElement(Col, { col: 5 },
                    React.createElement(StyledButton, { disabled: !coupon, onClick: applyCoupon, variant: coupon == '' ? undefined : 'primary', "data-track-content": true, "data-content-region-name": "applyInputCoupon", "data-content-name": coupon }, t('Áp dụng ngay')))),
            React.createElement(AppliedCouponBlock, null,
                appliedEVouchers.map(({ voucherCode, amount, promotionId }) => (React.createElement(StyledAppliedCoupon, { key: promotionId, text: voucherCode, discount: amount, type: "coupon", action: onRemoveCoupon }))),
                appliedCoupons.map(({ discount, type, text, promotionId }) => {
                    return (React.createElement(StyledAppliedCoupon, { key: promotionId, discount: discount, type: type, text: text, action: onRemoveCoupon }));
                })),
            !isLoggedIn && (React.createElement(Warning, null,
                t('src.Cart.CartDiscount.CartDiscountSeller.0'),
                React.createElement(StyledLink, { onClick: () => onLogin() }, t('đăng nhập')),
                t('để xem tất cả mã khuyến mại của bạn'))),
            (!!appliedCoupons.length || !!appliedEVouchers.length) && (React.createElement(StyledAlerts, { color: "#f78212", text: t('src.Cart.CartDiscount.CartDiscountSeller.1'), icon: "caution", size: "sm" })),
            React.createElement(StyledCoupons, null,
                Boolean(marketPlaceCoupons === null || marketPlaceCoupons === void 0 ? void 0 : marketPlaceCoupons.length) && (React.createElement(React.Fragment, null,
                    React.createElement(Header, null, t('Giảm giá toàn đơn')),
                    React.createElement("div", { className: "blockCouponSeller" }, marketPlaceCoupons.map((currentCoupon, id) => currentCoupon.text.trim().toUpperCase() !== coupon && (React.createElement(StyledSuggestedCoupon, { key: id },
                        React.createElement(SuggestedCoupon, Object.assign({}, currentCoupon, { appliedSellers: getAppliedSellersText(currentCoupon === null || currentCoupon === void 0 ? void 0 : currentCoupon.applySellerIds), action: () => onApplyCoupon(currentCoupon.text), horizontal: false })))))))),
                sellerSuggestedCoupons.map((item, i) => (React.createElement("div", { className: "blockCouponSeller", key: i },
                    multiSeller && (React.createElement(SellerCard, { marginTop: 12, marginBottom: 12, name: item.seller.displayName, avatar: item.seller.logo, avatarSize: "sm", showSlogan: false, showTick: false })),
                    item.suggestedCoupons.map((currentCoupon, index) => {
                        return (currentCoupon.text.trim().toUpperCase() !== coupon && (React.createElement(StyledSuggestedCoupon, { key: `suggested-coupon-${index}` },
                            React.createElement(SuggestedCoupon, Object.assign({}, currentCoupon, { action: () => onApplyCoupon(currentCoupon.text), horizontal: false })))));
                    }))))))));
};

const Wrapper$1 = styled.div `
  color: #848788;
  font-size: 0.875rem;
  display: flex;
  flex-wrap: wrap;
`;
const Variant = styled.div `
  display: flex;
`;
const Divider = styled.span `
  margin: 0 8px;
  color: #848788;
`;
const Variants = ({ variants = [], }) => (React.createElement(Wrapper$1, null, variants.map((variant, index) => (React.createElement(Variant, { key: index },
    React.createElement("div", null,
        variant.name,
        ": ",
        variant.value),
    index !== variants.length - 1 && React.createElement(Divider, null, "|"))))));

const Wrapper = styled.div `
  display: flex;
`;
const ProductName = styled.p `
  padding: 0;
  margin: 0;
  font-size: 0.875rem;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const Left = styled.div `
  display: flex;
  align-items: center;
`;
const Right = styled.div `
  flex: 1;
  margin-left: 1rem;
`;
const Action = styled.span(({ mgl = true }) => `
      font-size: 14px;
      color: #047fff;
      margin-left: ${mgl ? '1.5rem' : 0};
      cursor: pointer;
      display: inline-block;
      width: max-content;
      flex-shrink: 0;
    `);
const ComboList = styled.ul `
  padding: 0.25rem 0.75rem;
  list-style-type: none;
  border-radius: 0.5rem;
  box-shadow: 0 2px 0.5rem 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  background-color: white;
  margin: 0;
  width: max-content;
  max-width: 25rem;
`;
const StyledDropdown = styled(Dropdown) `
  width: max-content;
`;
const popperConfig = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [0, 10],
            },
        },
    ],
};
const StyledGift$1 = styled(Gift) `
  margin: 0.5rem 0;
`;
const SKU = styled.div `
  color: #848788;
  font-size: 0.875rem;
`;
const ProductInfo = ({ product: { sku, imageUrl, name, variants = [], combos = [], link, childItems = [], }, className, }) => {
    const [comboOpen, setComboOpen] = useState(false);
    const isCombo = childItems.length > 0;
    const toggleCombo = () => {
        setComboOpen((prev) => !prev);
    };
    const image = isCombo ? (React.createElement(ComboImage, { images: getComboImageUrl(childItems) })) : (React.createElement(LazyImage, { height: 80, width: 80, contain: true, border: true, src: imageUrl, alt: "product" }));
    const productName = isCombo ? getComboName(childItems) : name;
    return (React.createElement(Wrapper, { className: className },
        React.createElement(Left, null, image),
        React.createElement(Right, null,
            React.createElement(MobileLink, Object.assign({}, link),
                React.createElement("a", { target: "_blank", style: { color: 'unset', textDecoration: 'unset' } },
                    React.createElement(ProductName, null, productName))),
            sku && React.createElement(SKU, null,
                "SKU: ",
                sku),
            !!variants.length && React.createElement(Variants, { variants: variants }),
            !!combos.length && (React.createElement(StyledDropdown, { isOpen: comboOpen, toggle: toggleCombo, toggleType: "hover" },
                React.createElement(DropdownToggle, { toggleType: "hover" },
                    React.createElement(Action, { mgl: false }, "Xem combo")),
                React.createElement(DropdownMenu, { popperConfig: popperConfig, origin: "left top" },
                    React.createElement(ComboList, null, combos.map(({ imageUrl, name }, index) => (React.createElement(StyledGift$1, { key: index, image: {
                            src: imageUrl,
                        }, text: name }))))))))));
};

const StyledCard = styled(Card) `
  padding: 1rem;
`;
const StyledProductPrice = styled(ProductPrice) `
  text-align: right;
  justify-content: flex-end;
`;
const StyledGift = styled(Gift) `
  margin: 0.5rem 0;
`;
const GiftBlock = styled.div `
  margin-left: 3rem;
`;
const CartLinePrint = (_a) => {
    var { product } = _a, props = __rest(_a, ["product"]);
    return (React.createElement(StyledCard, Object.assign({}, props),
        React.createElement(Row, null,
            React.createElement(Col, { col: 7 },
                React.createElement(ProductInfo, { product: product })),
            React.createElement(Col, { col: 2.5 },
                React.createElement("span", null,
                    "x",
                    product.quantity)),
            React.createElement(Col, { col: 2.5 },
                React.createElement(StyledProductPrice, { listedPrice: product.price, price: product.discountPrice }))),
        !!get(product, 'gifts', []).length && (React.createElement(Row, null,
            React.createElement(Col, { col: 7 },
                React.createElement(GiftBlock, null, product.gifts.map((gift, index) => (React.createElement(StyledGift, { key: index, image: {
                        src: gift.imageUrl,
                    }, text: gift.name })))))))));
};

export { CartDiscountSeller as C, EmptyCartPanel as E, CartLinePrint as a };
